import React, {useState} from 'react'
import { Form, Button, FloatingLabel, Col } from 'react-bootstrap'

export default function MeditationEditForm(props) {
    const [newMeditation, setNewMeditation] = useState(props.meditation)

    const handleChange = (event) =>{
        const attributeToChange = event.target.name
        const newValue = event.target.value
    
        const meditation = {...newMeditation}
        meditation[attributeToChange] = newValue
        // console.log(meditation)
        setNewMeditation(meditation)
    }
    
    const handleSubmit = (event) => {
        event.preventDefault();
        props.editMeditation(newMeditation);
        event.target.reset();
    }
    
    
      return (
        <div>
    
        <Form onSubmit={handleSubmit}>
            <Col xs={12} sm={8} className="center-form">
            <FloatingLabel controlId="floatingInput" label="Name" className="mb-3">
                <Form.Control type="text" name="name" placeholder="Name" onChange={handleChange} value={newMeditation.name}></Form.Control>
            </FloatingLabel>
            <FloatingLabel controlId="floatingTextarea2" label="Description" className="mb-3">
                <Form.Control as="textarea" name="description" placeholder="Description" style={{ height: '100px' }} onChange={handleChange} value={newMeditation.description}></Form.Control>
            </FloatingLabel>
            <FloatingLabel controlId="floatingInput" label="Duration" className="mb-3">
                <Form.Control type="number" name="duration" placeholder="Duration" onChange={handleChange} value={newMeditation.duration}></Form.Control>
            </FloatingLabel>
            <Button variant="dark" type="submit" value="Update Meditation" onClick={props.onHide}>Save</Button>
            </Col>
        </Form>
        </div>
      )
    }
    